<template>
  <div class="grid-container sm:justify-center">
    <div
      class="flex flex-col justify-center gap-4 w-full pt-6 md:pt-14 sm:col-span-6 sm:col-start-3 md:col-start-5"
    >
      <h1 class="headline-lg text-center">
        ¡Gracias por registrarte! <br />
        Ahora, verifica tu cuenta
      </h1>
      <p class="title-lg text-center">
        Hemos enviado a tu correo un enlace para verificar tu cuenta. Haz click en ese enlace para
        finalizar tu proceso de registro.
      </p>
      <div class="flex justify-center">
        <Illustration name="mail-sent" width="230" height="206" />
      </div>
      <div class="flex flex-col gap-2 justify-center text-center p-2">
        <p class="title-md">¿No encuentras el correo?</p>
        <p class="title-sm">
          Recuerda buscar en tu buzón de promociones o spam. <br />
          Si no lo encuentras en tu buzón o si el link de validación ha expirado, haz click en el
          siguiente botón para enviarte un nuevo correo electrónico.
        </p>
        <Link
          method="post"
          as="button"
          type="button"
          class="block mx-auto btn-tonal py-2.5 px-6"
          :disabled="this.notificationSent"
          :href="$route('verification.send')"
        >
          {{ this.notificationSent ? 'Reenviado' : 'Reenviar correo' }}
        </Link>
      </div>
    </div>
  </div>
  <!-- <div class="container my-5">
    <div class="container-sm ">
      <div class="d-block mx-auto">
        <MailSent :width="230" :height="230" accentColor="#a7d212"></MailSent>
      </div>
      <div class="w-100 w-75-md mx-auto p-0 p-5-md text-center">
        <h1 class="fw-bold">
          ¡Gracias por registrarte!
        </h1>
        <h3 class="text-secondary">
          Hemos enviado un enlace para verificar tu cuenta a tu correo <strong>{{ email }}</strong
          >. <br />
          Haz click en ese enlace para finalizar tu proceso de registro.
        </h3>
      </div>
      <div class="mt-5 mx-auto mw-50 d-flex justify-content-center">
        <div class="col-12 col-lg-6 ">
          <hr />
          <h4 class="text-center">
            ¿No encuentras tu correo?
          </h4>
          <p class="text-secondary text-center">
            Si no lo encuentras en tu buzón o si el link de validación ha expirado, haz click en el
            siguiente botón para enviarte un nuevo correo electrónico.
          </p>
          <Link
            :href="$route('verification.send')"
            method="post"
            as="button"
            type="button"
            :disabled="this.notificationSent"
            :class="[
              'd-block mx-auto btn px-5 mt-2 btn-default',
              { 'btn-black': this.notificationSent },
            ]"
          >
            {{ this.notificationSent ? 'Reenviado' : 'Reenviar correo' }}
          </Link>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import { Link } from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/Layout.vue'
import MailSent from '@/Components/Illustrations/MailSent.vue'
import Illustration from '@/Components/Illustration.vue'

export default {
  layout: Layout,
  props: {
    notificationSent: { type: Boolean, default: false },
  },
  data() {
    return {
      // notificationSent: false,
    }
  },
  components: { MailSent, Link, Illustration },
  computed: {
    email() {
      return this.$page.props.auth.user.email
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../scss/utilities/theme';
@import '../../../scss/utilities/mixins';

.container {
  display: flex;
  justify-content: center;

  .section-container {
    padding-top: 56px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .illustration-container {
      display: flex;
      justify-content: center;
    }

    .resend-notification-container {
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 8px;
      text-align: center;
      padding: 8px;
    }

    // Apply styles on large screens
    @include md1 {
      width: 552px;
    }
  }
}
</style>
